// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2d8qe","info":"PatientInfo_info__2jPFi"};